import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert } from '@mui/material';
import PropTypes from 'prop-types';
import { selectAlertMessage, cleanAlertMessage } from '../../features/layoutSlice';

function MessAlert({ closeAfter = 5000 }) {
  const dispatch = useDispatch();
  const messageFromStore = useSelector(selectAlertMessage);

  React.useEffect(() => {
    if (!closeAfter) return () => {};
    let timerID;
    if (messageFromStore.text) {
      timerID = setTimeout(() => {
        dispatch(cleanAlertMessage());
      }, closeAfter);
    }
    return () => {
      clearTimeout(timerID);
    };
  }, [dispatch, messageFromStore.text, closeAfter]);

  const handleClose = () => {
    dispatch(cleanAlertMessage());
  };

  if (!messageFromStore.text) return null;

  return (
    <Alert data-testid="MessAlert" severity={messageFromStore.type} onClose={handleClose} sx={{ width: '100%' }}>
      {messageFromStore.text}
    </Alert>
  );
}

MessAlert.propTypes = {
  closeAfter: PropTypes.number,
};

export default MessAlert;
